import { AxiosInstance } from 'axios';
import { IMessage, IUser } from '../interfaces/entities';
import { ServiceBaseConfig } from './Interfaces/IAccountService';

export interface SendMessagePayload {
  to: string;
  content: string;
  type: string;
  file?: File;
}

export interface SendMessageResponse {
  success: boolean;
}

export interface ListUsersResponse {
  users: IUser[];
}

export interface ListUserMessagesResponse {
  messages: IMessage[];
}

export class ChatService {
  public static async listUsers(api: AxiosInstance, config: ServiceBaseConfig, filters?: { name?: string }): Promise<ListUsersResponse> {
    const { data } = await api.get('/users/list', { ...config, params: filters });

    return data;
  }

  public static async getUser(api: AxiosInstance, id: number, config: ServiceBaseConfig): Promise<any> {
    const { data } = await api.get(`/users/${id}`, config);

    return data;
  }

  public static async me(api: AxiosInstance, config: ServiceBaseConfig): Promise<any> {
    const { data } = await api.get('/users/me', config);

    return data;
  }

  public static async listUserMessages(api: AxiosInstance, id: number, config: ServiceBaseConfig): Promise<ListUserMessagesResponse> {
    const { data } = await api.get(`/messages/${id}`, config);

    return data;
  }

  public static async send(api: AxiosInstance, payload: SendMessagePayload, config: ServiceBaseConfig): Promise<SendMessageResponse> {
    const { data } = await api.post('/messages/store', payload, config);

    return data;
  }
}

